export enum InsurancePolicyListGroupButtons {
    POLICIES_SOON_TO_EXPIRE = '1',
    PENDING_RENEWAL_DUE_TO_BALANCE = '2',
    EXPIRED_AND_NOT_RENEWED = '3',
    GROUP_LIFE_LCT = '4',
    GROUP_LIFE_NOT_UPDATED = '5',
    LAST_ENDORSEMENT_REVERSAL = '6',
    WITHDRAWAL_REQUESTS = '7',
    ENDORSEMENTS_INCREASE_AUTOS = '8',
    ENDORSEMENTS_INCREASE_ELEVATORS_BOILERS = '9',
}